if (!customElements.get('loz-pair')) {
  customElements.define('loz-pair', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelector('form').addEventListener('submit', async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const button = form.querySelector('button');
        const status = this.querySelector('.loz-pair-status');
        if (button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = '';
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = new FormData(form);
        if (cart) {
          body.append('sections', cart.getSectionsToRender().map(section => section.id).join(','));
          body.append('sections_url', window.location.pathname);
          cart.setActiveElement(button);
        }
        try {
          const response = await fetch(form.action, {method: 'POST', headers: {'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json'}, body});
          let data = await response.json();
          if (!response.ok || data.status) {
            status.textContent = data.description || 'We could not add this pair. Please check the cart before trying again.';
            return;
          }
          status.textContent = 'Both boxes added to your cart.';
          if (this.dataset.discountCode) {
            const code = this.dataset.discountCode;
            const root = window.Shopify.routes.root;
            const current = await fetch(root + 'cart.js', {headers: {'Accept': 'application/json'}}).then(result => result.json());
            const applications = [...(current.cart_level_discount_applications || []), ...current.items.flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
            const codes = [...new Set([...applications.filter(application => application.type === 'discount_code').map(application => application.title), code])];
            const update = {discount: codes.join(','), sections_url: window.location.pathname};
            if (cart) update.sections = cart.getSectionsToRender().map(section => section.id);
            const discountResponse = await fetch(root + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(update)});
            const discounted = await discountResponse.json();
            if (!discountResponse.ok) {
              status.textContent = 'Both boxes were added. Enter ' + code + ' at checkout for the eligible offer.';
            } else {
              data = discounted;
              const applied = [...(data.cart_level_discount_applications || []), ...data.items.flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
              status.textContent = applied.some(application => application.title.toUpperCase() === code.toUpperCase()) ? 'Both boxes added. Your 15% saving is shown in the cart.' : 'Both boxes added. Check your cart for the best eligible offer; discounts do not combine.';
            }
          }
          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'loz-pair', cartData: data});
          if (cart && data.sections) {
            cart.classList.remove('is-empty');
            cart.renderContents({...data, id: data.items?.[0]?.id});
          } else {
            window.location.assign(window.routes.cart_url);
          }
        } catch {
          status.textContent = 'Please check your cart before trying again. The connection was interrupted.';
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    }
  });
}
